import './App.css';

function App() {
  return (
    <div className="App">
      <div className="wip-container">
        <div className="wip-con tent">
          <h1>Lucrare în curs</h1>
          <p>Pagina este în prezent în construcție. Vă rugăm să reveniți ulterior.</p>        </div>
      </div>
    </div>
  );
}

export default App;
